import React from 'react';

const Blogs = () => {
    return (
        <div id='blogs' className='mt-40'>
            <h1 className='text-center my-10 text-4xl font-bold text-white'>Blogs are  <span className='text-neutral' >coming soon ...</span></h1>
        </div>
    );
};

export default Blogs;